<template lang="pug">
SideModal(v-model="showVehicleDetailModal"  max-width="946")
  h2.primary--text.mb-5 Detalle

  .flex-col.gap-2(v-if="selectedVehicle")
    VehicleInfo

    OTHistory(:params="otListParams")
</template>

<script>
import { mapWritableState } from 'pinia'
import { useVehicleListStore } from '../../../stores/views/useVehicleListStore'
import SideModal from '@/components/shared/SideModal.vue'
import VehicleInfo from './DetailModal/VehicleInfo.vue'
import OTHistory from '@/components/shared/OTHistory.vue'

export default {
  components: {
    SideModal,
    VehicleInfo,
    OTHistory,
  },

  data() {
    return {
      tab: 0,
    }
  },

  computed: {
    ...mapWritableState(useVehicleListStore, [
      'showVehicleDetailModal',
      'selectedVehicle',
    ]),

    otListParams() {
      return {
        vehicle: this.selectedVehicle?.id,
      }
    },
  },

  watch: {
    async showVehicleDetailModal(val) {
      if (!val) {
        await this.$nextTick()
        this.selectedVehicle = null
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
